import React from 'react'
import { Table } from 'semantic-ui-react'

export default class SortableHeaderCell extends React.Component {
  render() {
    const { name, title, sortCol, direction, onClick, width, ...rest } = this.props
    return (
      <Table.HeaderCell
        width={width}
        content={title}
        sorted={sortCol === name ? direction : undefined}
        onClick={onClick}
        {...rest}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Helpers/SortableHeaderCell.jsx